export const ATTEMPT_NUMBERS = ['no', 'one', 'two', 'three'];
